'use strict';

var chunkJRIEAGIQ_js = require('./chunk-JRIEAGIQ.js');
require('./chunk-GONKA3OC.js');



Object.defineProperty(exports, "accountParser", {
  enumerable: true,
  get: function () { return chunkJRIEAGIQ_js.accountParser; }
});
